export default "__VITE_ASSET__o6py23Vj__"